/**
 * Forthbridge Clinical Document
 * Forthbridge Clinical Document API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResponseMetaDto } from './responseMetaDto';


export interface SuccessResponseDto { 
    /**
     * Indicates successful operation
     */
    success: SuccessResponseDto.SuccessEnum | null;
    /**
     * Response metadata
     */
    meta: ResponseMetaDto;
    /**
     * Response data
     */
    data: any;
}
export namespace SuccessResponseDto {
    export type SuccessEnum = {};
    export const SuccessEnum = {
    };
}


